/**
 * Helpers de calcul de la durée d'un shift.
 *
 * - `hoursBetween` : durée brute entre deux HH:MM (gère le passage minuit).
 * - `unpaidBreakHours` : cumul des pauses "non rémunérées".
 * - `effectiveShiftHours` : durée effective = brute − pauses non rémunérées.
 *
 * Les "heures planifiées" affichées aux collaborateurs et à l'administration
 * doivent utiliser `effectiveShiftHours` afin de ne pas compter les pauses
 * non rémunérées (règle métier).
 */

export function hoursBetween(start, end) {
  if (!start || !end) return 0;
  try {
    const [sh, sm] = start.split(":").map(Number);
    const [eh, em] = end.split(":").map(Number);
    let diff = (eh * 60 + em) - (sh * 60 + sm);
    if (diff < 0) diff += 24 * 60; // passage minuit
    return Math.max(0, diff / 60);
  } catch {
    return 0;
  }
}

export function unpaidBreakHours(breaks) {
  if (!Array.isArray(breaks) || breaks.length === 0) return 0;
  return breaks.reduce((acc, b) => {
    if (b && !b.is_paid) return acc + hoursBetween(b.start_time, b.end_time);
    return acc;
  }, 0);
}

export function effectiveShiftHours(shift) {
  if (!shift) return 0;
  const total = hoursBetween(shift.start_time, shift.end_time);
  const unpaid = unpaidBreakHours(shift.breaks);
  return Math.max(0, total - unpaid);
}
